import { useAppContext } from '../../Services/AppContext';

export default function CaseChatEntryFileProcessing() {
	const { translation } = useAppContext();

	return (
		<div className='chat-window__antivirus-wrapper'>
			<div className='w-100'>
				<div className='sk-circle'>
					<div className='sk-circle1 sk-child'></div>
					<div className='sk-circle2 sk-child'></div>
					<div className='sk-circle3 sk-child'></div>
					<div className='sk-circle4 sk-child'></div>
					<div className='sk-circle5 sk-child'></div>
					<div className='sk-circle6 sk-child'></div>
					<div className='sk-circle7 sk-child'></div>
					<div className='sk-circle8 sk-child'></div>
					<div className='sk-circle9 sk-child'></div>
					<div className='sk-circle10 sk-child'></div>
					<div className='sk-circle11 sk-child'></div>
					<div className='sk-circle12 sk-child'></div>
				</div>
				<div className='page-loader-wrapper__title'>
					{translation['component.files.antivirCheck']}
				</div>
			</div>
		</div>
	);
}
